import React from 'react';

import RulesTable from './RulesTable';

const Rules = () => (
  <div data-cy="top-level-rules" style={{ width: '100%' }}>
    <RulesTable/>
  </div>
);

export default Rules;
